import script from "./CaseStudies-Data-Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseStudies-Data-Editor.vue?vue&type=script&setup=true&lang=js"

import "./CaseStudies-Data-Editor.vue?vue&type=style&index=0&id=7a331980&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a331980"]])

export default __exports__